import { render, staticRenderFns } from "./PlayerGameName.vue?vue&type=template&id=ebb4df46&lang=pug"
import script from "./PlayerGameName.vue?vue&type=script&lang=js"
export * from "./PlayerGameName.vue?vue&type=script&lang=js"
import style0 from "./PlayerGameName.vue?vue&type=style&index=0&id=ebb4df46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports